const KEY = 'ALERTBAND';

export function showAlertBand(alert) {
  return {
    type: `${KEY}_SHOW`,
    payload: alert
  };
}

export function dismissAlertBand(alertId) {
  return {
    type: `${KEY}_DISMISS`,
    payload: { id: alertId }
  };
}

export function resetAlertBand() {
  return {
    type: `${KEY}_RESET`,
    payload: null
  };
}
